
import React from 'react';
import { Tooltip } from '@mui/material';
import styled from 'styled-components';
import Help from '@mui/icons-material/Help';

export const HelpIcon = ({ text }) => {
  return (
    <Tooltip title={text} placement="top">
      <IconButton>?</IconButton>
    </Tooltip>
  );
};

const IconButton = styled.div`
  background-color: #EAF0F6;
  color: #0072A2;
  width: 32px;
  height: 32px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 16px;
  display: inline-block;
  text-align: center;
  margin-left: 8px;
  padding-top: 3px;
  box-sizing: border-box;
  cursor: pointer;
  margin-right: 8px;
`;